export default __webpack_public_path__ + "static/media/GroupsMobileActive.d6a87c78.svg";